import React from 'react';
import MassNotification from '../../../models/MassNotification';
import Pagination from '../../../models/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, Paper, darken, Tooltip } from  '@mui/material';
import PaginationButtons from '../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow } from '../../Utils/ISTable';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { personTypeToDescription } from '../../Client/Profile';
import { useThemeContext } from '../../../theme/ThemeContext';

export interface Row {
  data: MassNotification
  action?: 'create' | 'update' | 'error';
}

interface Props {
  rows: Row[];
  loading: boolean;
  pagination?: Pagination;
  fromIn?: boolean;
  adminInfo?: boolean;
  managerInfo?: boolean;
  onClickInfo?: (massNotification: MassNotification) => void;
  onChangePage?: (page: number) => void;
}

const MassNotifications: React.FC<Props> = (props) => {  
  const { t } = useTranslation(['massNotification', 'person'])
  const { theme } = useThemeContext();

  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }
  return (
      <Paper style={{borderRadius: "10px", margin: props.fromIn ? "-10px" : "10px"}}>
      { !props.fromIn && <ISTableTitle title={t('notifications')}/> }
      <Table style={{whiteSpace:"nowrap", overflow:"hidden"}} size="medium" >
        <TableHead>
          <TableRow selected={true}>
            <ISTableHeaderCell align='center'>{t('scheduledDate')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('title')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('message')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('url')}</ISTableHeaderCell>           
            <ISTableHeaderCell>{t('personType')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('toPersonTypeId')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('status')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('createdBy')}</ISTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { !props.loading && props.rows.map((row, index) =>
            <ISTableRow key={index} color={mapActionToColor(row.action)} sx={{cursor: row.data.status !== 'SENT' ? 'pointer' : 'inherit', backgroundColor: row.data.status === 'SENT' ? darken(theme.palette.action.hover, 0.1) : ''}}
            onClick={(e) => { e.stopPropagation(); props.onClickInfo && row.data.status !== 'SENT' && props.onClickInfo(row.data) }}>
              <TableCell align='center'>{moment(new Date(row.data.scheduledDate!)).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY HH:mm')}</TableCell>
              <TableCell>{row.data.title}</TableCell>
              <Tooltip title={row.data.message}><TableCell style={{ maxWidth: '300px',  overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.data.message}</TableCell></Tooltip>
              <Tooltip title={row.data.url}><TableCell style={{ maxWidth: '300px',  overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.data.url}</TableCell></Tooltip>
              <TableCell>{t(personTypeToDescription(row.data.personType!), { ns: 'person'})}</TableCell>
              <TableCell>{row.data.toPersonTypeId}</TableCell>
              <TableCell>{t(row.data.status!)}</TableCell>
              <TableCell>{row.data.owner?.fullName}</TableCell>
            </ISTableRow>
          )}
        </TableBody>
      </Table>
      { props.loading &&
        <div style={{display:'flex', justifyContent:'center'}}>
          <CircularProgress size={25} />
        </div>
      }
      <PaginationButtons pagination={props.pagination} />
    </Paper>
  );
}

export default MassNotifications